import * as React from 'react';

import LogoImage from './logo.svg';
import * as Styled from './Logo.style';

interface ILogoProps {
  locale?: string;
}

const sites = [
  'https://www.littlecaesars.com/en-us/',
  'https://www.littlecaesars.com/es-us/',
];

const Logo: React.FC<ILogoProps> = ({ locale = 'en-us' }) => {
  const url = sites.find(site => site.includes(locale)) || sites[0];
  return (
    <Styled.Anchor data-testid="Navigate" href={ url } title="Little Caesars">
      <LogoImage />
    </Styled.Anchor>
  );
};

export default Logo;
